import {
  WIRCreateJourneyStepsKeys,
  WIRKofMeetingTechnicalWirSectionKey,
  WIRKofMeetingTechnicalWirSections,
} from 'pages/WellGuardian/WIR/wir.constants';
import { CountryData, WIR } from 'types/wellGuardian';

export const getKomTechnicalWirSections = (wir: WIR | null, country: string) => {
  if (country === CountryData.congo) {
    return (
      (wir &&
        Object.keys(WIRKofMeetingTechnicalWirSections).map(item => ({
          label: WIRKofMeetingTechnicalWirSections[item as WIRKofMeetingTechnicalWirSectionKey],
          value: item,
          phase: WIRCreateJourneyStepsKeys.CG_KICK_OFF_TECHNICAL_WIR,
        }))) ??
      []
    );
  } else {
    return (
      (wir &&
        Object.keys(WIRKofMeetingTechnicalWirSections)
          .map(item => ({
            label: WIRKofMeetingTechnicalWirSections[item as WIRKofMeetingTechnicalWirSectionKey],
            value: item,
            phase: WIRCreateJourneyStepsKeys.KICK_OFF_TECHNICAL_WIR,
          }))
          .filter(
            stepItem =>
              stepItem.label !== WIRKofMeetingTechnicalWirSections.organiseKickOffMeeting &&
              stepItem.label !== WIRKofMeetingTechnicalWirSections.budget,
          )) ??
      []
    );
  }
};
